import { render, staticRenderFns } from "./DatabaseNode.vue?vue&type=template&id=46ca824a&"
import script from "./DatabaseNode.vue?vue&type=script&lang=js&"
export * from "./DatabaseNode.vue?vue&type=script&lang=js&"
import style0 from "./DatabaseNode.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports